<template>
  <div class="muzik-member mk-container">
    <div class="pgnnp-header">
      <Paganiniplus />
    </div>
    <Breadcrumbs />
    <div v-if="loaded">
      <div v-if="memberData !== null" class="wrapper">
        <div v-if="memberData !== null" class="user-block">
          <div class="user-image">
            <img v-img-loader
                 :data-src="memberData.avatar"
                 :data-default-src="'/img/img-default/img-user-default-l.png'" alt="user image"
            >
          </div>
          <div v-if="memberData.name" class="user-info">
            <h1 class="title">
              {{ memberData.name ? memberData.name : '-' }}
            </h1>
            <p v-if="memberData.user_detail !== null" class="desp">
              {{ memberData.user_detail.description ? memberData.user_detail.description : '-' }}
            </p>
            <div v-if="uesrLogin!=='' && isUserSelf" class="user-option">
              <a class="edit" @click="modalActive.editUser=true">
                <i class="material-icons">
                  edit
                </i>
              </a>
            </div>
          </div>
        </div>
        <div class="player-list">
          <!-- Playlist -->
          <div v-if="(playlistData && playlistData.length) || isUserSelf"
               class="block-list playlist-list"
          >
            <h2 class="title">
              {{ $t('PLAYLIST.ALL_PLAYLIST') }}
            </h2>
            <div class="block-option">
              <a v-if="playlistData.length && uesrLogin!=='' && isUserSelf" @click="addPlaylist">
                <i class="material-icons">
                  add_circle_outline
                </i>
                {{ $t('COMMON.ADD') }}
              </a>
            </div>
            <ul v-if="playlistData && playlistData.length" data-cy="playlist">
              <li v-for="(item, index) in playlistData" :key="index">
                <div class="block-grid">
                  <!-- <router-link :to="{ name:'playlistById', params: { locale: $i18n.localePath(), id: item.id } }" class="block-link" /> -->
                  <a href="#" class="block-link" @click="routeTo('playlistById', item.id)" />
                  <div class="block-img">
                    <img v-if="item.file_id !== null && item.file_link" v-img-loader
                         :data-src="item.file_link"
                         :data-default-src="'/img/img-default/img-playlist-default-l.png'"
                    >
                    <img v-else v-img-loader
                         :data-default-src="'/img/img-default/img-playlist-default-l.png'"
                         class="show" alt="playlist image"
                    >
                  </div>
                  <Dropdown v-if="uesrLogin!=='' && isUserSelf" ref="dropdown"
                            :dropdown-active="item.dropdown"
                            @update="updateDropdownStatus(item)"
                  >
                    <template slot="option">
                      <i class="material-icons">
                        more_vert
                      </i>
                    </template>
                    <template slot="content">
                      <ul>
                        <li @click="editPlaylist(item)">
                          <i class="material-icons">
                            create
                          </i>{{ $t('COMMON.EDIT') }}
                        </li>
                        <li @click="deleteComfirm(item)">
                          <i class="material-icons">
                            delete
                          </i>{{ $t('COMMON.DELETE') }}
                        </li>
                      </ul>
                    </template>
                  </Dropdown>
                </div>
                <!-- <router-link :to="{name:'playlistById', params:{locale: $i18n.localePath(), id:item.id}}" tag="p" class="title pointer">{{ item.title }}</router-link> -->
                <p class="title pointer" @click="routeTo('playlistById', item.id)">
                  {{ displayLocaleTitle(item) }}
                </p>
              </li>
            </ul>
            <ul v-else-if="isUserSelf" data-cy="playlist">
              <li>
                <div class="block-grid dummy" data-cy="addPlaylist" @click="addPlaylist">
                  <div class="btn-circle">
                    <i class="material-icons">
                      add
                    </i>
                  </div>
                </div>
                <p class="title">
                  {{ $t('PLAYLIST.ADD_PLAYLIST') }}
                </p>
              </li>
            </ul>
          </div>
          <!-- Following Playlist -->
          <div v-if="(followlistData && followlistData.length) || isUserSelf"
               class="block-list following-list"
          >
            <h2 class="title">
              {{ $t('PLAYLIST.SAVE') }}
            </h2>
            <ul v-if="followlistData && followlistData.length">
              <li v-for="(item, index) in followlistData" :key="index">
                <div class="block-grid">
                  <!-- <router-link :to="{name:'playlistById', params: { locale: $i18n.localePath(), id: item.id }}" class="block-link" /> -->
                  <a href="#" class="block-link" @click="routeTo('playlistById', item.id)" />
                  <div class="block-img">
                    <img v-img-loader
                         :data-src="item.file_link"
                         :data-default-src="'/img/img-default/img-playlist-default-l.png'" alt="playlist image"
                    >
                  </div>
                  <Dropdown v-if="uesrLogin!=='' && isUserSelf" ref="dropdown"
                            :dropdown-active="item.dropdown"
                            @update="updateDropdownStatus(item)"
                  >
                    <template slot="option">
                      <i class="material-icons">
                        more_vert
                      </i>
                    </template>
                    <template slot="content">
                      <ul>
                        <li @click="unfollowPlaylist(item.id)">
                          <i class="material-icons">
                            favorite_border
                          </i>{{ $t('PLAYLIST.UNFOLLOW') }}
                        </li>
                      </ul>
                    </template>
                  </Dropdown>
                </div>
                <p class="title pointer" @click="routeTo('playlistById', item.id)">
                  {{ displayLocaleTitle(item) }}
                </p>
                <!-- <p v-else class="title pointer" @click="routeTo('playlistById', item.id)">{{ item.title }}</p> -->
                <!-- <router-link v-if="item.official_playlist_id" :to="{name:'playlistById', params:{locale: $i18n.localePath(), id:item.id}}" tag="p" class="title pointer">{{ item.title }}</router-link>
                <router-link v-else :to="{name:'playlistById', params:{locale: $i18n.localePath(), id:item.id}}" tag="p" class="title pointer">{{ item.title }}</router-link> -->
              </li>
            </ul>
            <ul v-else-if="isUserSelf">
              <CommonDummy :title="$t('PLAYLIST.EMPTY_PLAYLIST_TEXT')"
                           :btn="$t('PLAYLIST.VIEW_TOP10_PLAYLIST')"
                           :route-name="'scenarioById'" :page-id="'8bab9370-864f-48f8-81bf-db3decb14028'"
              />
            </ul>
          </div>
          <!-- Visitor 404 -->
          <CommonDummy v-if="!(playlistData && playlistData.length) && !(followlistData && followlistData.length) && !isUserSelf"
                       :title="$t('DUMMY.LISTEN_COMMON')"
          />
        </div>
      </div>
      <CommonDummy v-else
                   :title="$t('DUMMY.LISTEN_COMMON')"
      />
    </div>
    <div v-else class="loader-container">
      <Loader />
    </div>

    <MemberEditModal
      :user-data="JSON.parse(JSON.stringify(memberData))"
      :open="modalActive.editUser"
      @close="updateUser"
    />

    <PlaylistEditModal
      :playlist="playlist"
      :open="modalActive.playlist"
      @close="updatePlaylist"
    />

    <PlaylistDeleteModal
      :item="deletePlaylist"
      :open="modalActive.deleteComfirm"
      @close="deletePlaylists"
    />
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import Paganiniplus from '@/components/tsp/Paganiniplus'
import Breadcrumbs from '@/components/common/Breadcrumbs'
import Loader from '@/components/common/Loader'
import Dropdown from '@/components/common/Dropdown'
import CommonDummy from '@/components/common/DummyStatus/CommonDummy'
import PlaylistEditModal from '@/components/playlist/PlaylistEditModal'
import PlaylistDeleteModal from '@/components/playlist/PlaylistDeleteModal'
import MemberEditModal from '@/components/member/MemberEditModal'
import ImgLoader from '@/directives/ImgLoader'
import MemberService from '@/assets/services/MemberService'
import PlaylistService from '@/assets/services/PlaylistService'
import { getLocalStorage } from '@/assets/helpers/UtilHelper'
import { displayLocaleTitle } from '@/assets/helpers/PlaylistHelper'

export default {
  name: 'Member',
  components: {
    Paganiniplus,
    Breadcrumbs,
    Loader,
    Dropdown,
    CommonDummy,
    PlaylistEditModal,
    PlaylistDeleteModal,
    MemberEditModal
  },
  directives: {
    ImgLoader
  },
  props: {},
  data() {
    return {
      loaded: false,
      modalActive: {
        editUser: false,
        deleteComfirm: false,
        playlist: false
      },
      user: {
        id: '',
        year: '',
        month: '',
        date: ''
      },
      userToken: getLocalStorage('token'),
      isUserSelf: false,
      memberData: {},
      playlistData: {},
      playlist: {
        id: '',
        title: '',
        file: '',
        mode: 'add'
      },
      followlistData: [],
      deletePlaylist: {}
    }
  },
  metaInfo() {
    return {
      title: this.title,
      meta: [
        ...this.$route.meta.metaInfo.meta,
        { vmid: 'name', name: 'name', content: this.title },
        { vmid: 'description', name: 'description', content: this.description },
        { vmid: 'image', name: 'image', content: this.cover },
        { vmid: 'keywords', name: 'keywords', content: this.keywords },
        { vmid: 'og:title', name: 'og:title', content: this.title },
        { vmid: 'og:description', name: 'og:description', content: this.description },
        { vmid: 'og:image', name: 'og:image', content: this.cover }
      ],
      link: [
        { vmid: 'canonical', rel: 'canonical', href: this.canonicalURL },
        { vmid: 'image_src', rel: 'image_src', href: this.cover }
      ]
    }
  },
  computed: {
    ...mapState({
      uesrLogin: state => state.user.status,
      uesrProfile: state => state.user.profile
      // userPlaylist: state => state.user.playlist,
      // userFollowing: state => state.user.following,
    }),
    ...mapGetters({
      // getters
    }),
    title() {
      const productionLocaleName = this.$t(`${this.$production.toUpperCase()}.TITLE`)
      return this.uesrProfile && this.uesrProfile.name
        ? `${this.uesrProfile.name} | ${productionLocaleName} | MUZIK AIR`
        : `${this.$t('MEMBER.INDEX.TITLE')} | ${productionLocaleName} | MUZIK AIR`
    },
    description() {
      return this.title
    },
    keywords() {
      const productionLocaleName = this.$t(`${this.$production.toUpperCase()}.TITLE`)
      return this.uesrProfile && this.uesrProfile.name
        ? `${this.uesrProfile.name}, ${this.$t('MEMBER.INDEX.TITLE')}, ${productionLocaleName}, MUZIK AIR`
        : `${this.$t('MEMBER.INDEX.TITLE')}, ${productionLocaleName}, MUZIK AIR`
    },
    cover() {
      const subDomainKey = `VUE_APP_MUZIK_${this.$production.toUpperCase()}`
      const isAirProduction = (this.$production === 'AIR') &&
                              (process.env['VUE_APP_MUZIK_STAGE'] === 'production')
      const coverPath = this.$production.toLowerCase()
      return this.uesrProfile && this.uesrProfile.id
        ? this.uesrProfile.avatar
        : (isAirProduction
          ? `https://${process.env.VUE_APP_MUZIK_DOMAIN}/img/cover-social/${coverPath}.png`
          : `https://${process.env[subDomainKey]}.${process.env.VUE_APP_MUZIK_DOMAIN}/img/cover-social/${coverPath}.png`)
    },
    canonicalURL() {
      const subDomainKey = `VUE_APP_MUZIK_${this.$production.toUpperCase()}`
      const isAirProduction = (this.$production === 'AIR') &&
                              (process.env['VUE_APP_MUZIK_STAGE'] === 'production')
      return isAirProduction
        ? `https://${process.env.VUE_APP_MUZIK_DOMAIN}/${this.$i18n.localePath()}/member/${this.uesrProfile.id}`
        : `https://${process.env[subDomainKey]}.${process.env.VUE_APP_MUZIK_DOMAIN}/${this.$i18n.localePath()}/member/${this.uesrProfile.id}`
    }
  },
  watch: {
    '$route.params.id'(val) {
      this.checkUser()
    },
    uesrProfile(val) {
      if (val.id === this.memberData.id) {
        this.isUserSelf = true
      }
    }
  },
  created() {
  },
  mounted() {
    this.checkUser()
  },
  updated() {
  },
  methods: {
    displayLocaleTitle,
    async checkUser() {
      const userId = this.$route.params.id
      this.userToken = getLocalStorage('token')
      this.isUserSelf = (this.uesrProfile.id === userId)
      // console.log('Login: ' + this.uesrLogin)
      // console.log('Self:  ' + this.isUserSelf)
      if (userId.length === 36) {
        this.loaded = false
        this.playlistData = null
        switch ((this.uesrLogin === 'success') && this.isUserSelf) {
          case true:
            // console.log('is me')
            this.memberData = this.uesrProfile
            break
          case false:
            if (this.uesrLogin === 'pending') {
              await MemberService.getMe(this.userToken)
              // console.log('getMe again')
              if (this.uesrProfile.id === userId) {
                // console.log('is self')
                this.memberData = this.uesrProfile
                this.isUserSelf = true
              } else {
                // console.log('not self')
                await this.getUser(userId)
              }
            } else {
              await this.getUser(userId)
            }
            break
          default:
            await this.getUser(userId)
        }
        if (this.memberData && this.memberData.id) {
          this.playlistData = await this.getPlaylists(this.memberData.id)
          this.followlistData = await this.getFollowPlaylists(this.memberData.id)
        }
        this.loaded = true
      } else {
        this.memberData = null
        this.loaded = true
      }
    },
    async getUser(userId) {
      this.userToken = getLocalStorage('token')
      this.memberData = await MemberService.getUser(this.userToken, userId)
      if (this.uesrProfile.id === userId) {
        this.isUserSelf = true
      }
    },
    async updateUser(isUpdate) {
      if (isUpdate) {
        await this.getUser(this.memberData.id)
      }
      this.modalActive.editUser = false
    },
    async getPlaylists(userid) {
      const params = {
        'per_page': 100,
        'page': 1
      }
      if (userid) {
        params.q = {}
        params.q.user_id = userid
      }
      const playlists = await PlaylistService.getPlaylists(params)
      if (playlists && playlists.data) {
        playlists.data.map(item => {
          item.dropdown = false
        })
        return playlists.data
      } else {
        return null
      }
    },
    async getFollowPlaylists(userid) {
      const res = await PlaylistService.getPlaylistFollowing(userid)
      if (res && res.data) {
        res.data.map(item => {
          item.dropdown = false
        })
        return res.data
      } else {
        return null
      }
    },
    async addPlaylist() {
      this.playlist = {
        id: '',
        title: '',
        file: '',
        mode: 'add'
      }
      this.modalActive.playlist = true
    },
    async editPlaylist(item) {
      this.playlist.id = item.id
      this.playlist.title = item.title
      this.playlist.imageSrc = item.file_link
      this.playlist.mode = 'edit'
      item.dropdown = false
      this.modalActive.playlist = true
    },
    async deletePlaylists(isUpdate) {
      if (isUpdate) {
        this.playlistData = await this.getPlaylists(this.memberData.id)
        this.$store.commit('ALERT_MESSAGE', { message: 'PLAYLIST.REMOVE_SUCCESS', type: 'success' })
      }
      this.modalActive.playlist = false
      this.modalActive.deleteComfirm = false
    },
    async updatePlaylist(isUpdate) {
      if (isUpdate) {
        this.playlistData = await this.getPlaylists(this.memberData.id)
        this.$store.commit('ALERT_MESSAGE', { message: 'PLAYLIST.ADD_PLAYLIST_SUCCESS', type: 'success' })
      }
      this.modalActive.playlist = false
      this.modalActive.deleteComfirm = false
    },
    async unfollowPlaylist(playlistId) {
      const params = [playlistId]
      const res = await PlaylistService.deletePlaylistFollowing(params)
      if (res) {
        this.followlistData = await this.getFollowPlaylists(this.memberData.id)
        this.$store.commit('ALERT_MESSAGE', { message: 'PLAYLIST.REMOVE_PLAYLIST_SUCCESS', type: 'success' })
        this.$store.dispatch('UPDATE_USER_FOLLOWING') // Notify user store
      }
    },
    deleteComfirm(item) {
      this.deletePlaylist.id = item.id
      this.deletePlaylist.title = item.title
      item.dropdown = false
      this.modalActive.deleteComfirm = true
    },
    updateDropdownStatus(item) {
      item.dropdown = true
    },
    routeTo(routeName, paramId) {
      const production = this.$production.toUpperCase()
      if (production === 'LISTEN') {
        this.$router.push({ name: routeName, params: { id: paramId } })
      } else {
        const localePath = this.$i18n.localePath()
        const subDomain = process.env.VUE_APP_MUZIK_LISTEN
        const mainDomain = process.env.VUE_APP_MUZIK_DOMAIN
        const destURL = `https://${subDomain}.${mainDomain}/${localePath}/playlists/${paramId}`
        window.open(destURL, '_blank')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';
@import '@/assets/scss/component/button.scss';
@import '@/assets/scss/component/form.scss';
@import '@/assets/scss/component/radio.scss';
@import '@/assets/scss/component/checkbox.scss';

.muzik-member{
  .breadcrumbs{
    padding: 24px 0;
  }
  .pgnnp-header {
    margin-top: 24px;
  }
  .user-block{
    position: relative;
    margin: 40px 0 55px;
    .user-image{
      position: relative;
      // width: 10.6%;
      // padding-top: 10.6%;
      width: 130px;
      height: 130px;
      border-radius: 50%;
      overflow: hidden;
      float: left;
      background: #f5f5f5;
      text-indent: -100%;
      img{
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: auto;
        &.landscape{
          height: 100%;
          width: auto;
        }
      }
    }
    .user-info{
      overflow: hidden;
      padding-left: 24px;
      .title{
        font-size: 24px;
        font-weight: 500;
        line-height: 1.6;
        margin: 0 0 10px;
        color: $grey-50;
      }
      .desp{
        font-size: 16px;
        font-weight: bold;
        line-height: 1.6;
        color: $grey-9b;
      }
    }
    .user-option{
      position: absolute;
      top: 0;
      right: 0;
      a{
        cursor: pointer;
        i{
          color: $grey-9b;
        }
      }
    }
    &:after{
      content: "";
      display: block;
      clear: both;
    }
  }
  .player-list{
    margin: 0 0 30px;
    .block-list{
      position: relative;
      >.title{
        font-size: 20px;
        font-weight: 500;
        line-height: 1.6;
        color: $grey-50;
        margin: 12px 0 24px;
      }
      >ul{
        list-style: none;
        margin: 0;
        padding: 0;
        margin: 0 -21px 28px;
        >li{
          display: inline-block;
          position: relative;
          width: 20%;
          padding: 0 21px;
          float: left;
          text-align: center;
          .block-grid{
            position: relative;
            &.dummy{
              position: relative;
              padding-top: 89%;
              background: #f3f3f3;
              border-radius: 12px;
              cursor: pointer;
              .btn-circle{
                width: 48px;
                height: 48px;
                background: $theme-yellow;
                position: absolute;
                top: 0;
                bottom: 0;
                left: 0;
                right: 0;
                margin: auto;
                border-radius: 50%;
                i{
                  font-size: 36px;
                  width: 36px;
                  height: 36px;
                  color: #fff;
                  position: absolute;
                  top: 0;
                  bottom: 0;
                  left: 0;
                  right: 0;
                  margin: auto;
                }
              }
            }
            &:hover{
              .block-img::before{
                opacity: .3;
              }
              .dropdown{
                opacity: 1;
              }
            }
          }
          .block-link{
            position: absolute;
            width: 100%;
            height: 100%;
            top: 0;
            left: 0;
            z-index: 2;
          }
          .block-img{
            position: relative;
            padding-top: 89%;
            border-radius: 12px;
            overflow: hidden;
            img{
              position: absolute;
              top: 0;
              bottom: 0;
              left: 0;
              right: 0;
              margin: auto;
              width: 100%;
              height: auto;
              &.landscape{
                  height: 100%;
                  width: auto;
                  left: -50%;
                  right: -50%;
              }
            }
            &:before{
              content: "";
              display: block;
              position: absolute;
              top: 0;
              left: 0;
              background: #000;
              opacity: 0;
              width: 100%;
              height: 100%;
              z-index: 1;
              transition: .6s all;
            }
          }
          .title{
            font-size: 20px;
            line-height: 1.6;
            letter-spacing: -0.1px;
            color: $grey-50;
            margin: 12px 0 20px;
            height: 68px;
            overflow: hidden;
          }
          .dropdown{
            z-index: 3;
            opacity: 0;
            transition: .2s all;
            &.open{
              opacity: 1;
            }
          }
        }
        &::after{
          content: "";
          display: block;
          clear: both;
        }
      }
      .block-option{
        position: absolute;
        top: 0;
        right: 0;
        a{
          display: inline-block;
          color: $theme-red;
          font-size: 20px;
          font-weight: 500;
          cursor: pointer;
          i{
            vertical-align: middle;
            margin-right: 8px;
          }
        }
      }
    }
  }
  .loader-container{
    text-align: center;
    .loader{
      margin-bottom: 40px;
    }
  }
}

@media only screen and (min-width: 1440px) {
  //as default
}

@media only screen and (max-width: 1439.98px) {
  .muzik-member{
    .player-list{
      .block-list{
        >ul{
          margin: 0 -15px 28px;
          >li{
            padding: 0 15px;
            width: 16.66%;
            .title{
              font-size: 16px;
              height: 50px;
            }
          }
        }
      }
    }
  }
}

@media only screen and (max-width: 1023.98px) {
  .muzik-member{
    .user-block{
      margin: 12px 0 40px;
    }
    .player-list{
      .block-list{
        .title{
          margin-bottom: 16px;
        }
        >ul{
          margin: 0 -12.5px 10px;
          >li{
            padding: 0 12.5px;
          }
        }
      }
    }
  }
}

@media only screen and (max-width: 767.98px) {
  .muzik-member{
    .user-block{
      position: relative;
      text-align: center;
      margin: 0 0 30px;
      padding-bottom: 35px;
      .user-image{
        display: inline-block;
        width: 110px;
        height: 110px;
        float: none;
      }
      .user-info{
        padding: 0;
        .title{
          font-size: 20px;
          margin: 10px 0 7px;
        }
        .desp{
          margin: 0;
          font-size: 12px;
          font-weight: normal;
          line-height: normal;
          color: $grey-7d;
          text-align: left;
        }
      }
      .user-option{
        width: 24px;
        height: 24px;
        top: initial;
        bottom: 0;
        left: 0;
        margin: auto;
      }
    }
    .player-list{
      .block-list{
        >ul{
          margin: 0 -8px 28px;
          >li{
            width: 50%;
            padding: 0 8px;
          }
        }
      }
    }
  }
}
</style>

<style lang="scss">
.muzik-member{
  .player-list{
    .block-list{
      >ul{
        li{
          &:nth-child(5n){
            .dropdown-menu{
              left: initial;
              right: -13px;
              // left: 0;
              &:before{
                left: initial;
                right: 15px;
              }
            }
          }
        }
      }
    }
  }
}
@media only screen and (max-width: 1439.98px) {
  .muzik-member{
    .player-list{
      .block-list{
        >ul{
          li{
            &:nth-child(5n){
              .dropdown-menu{
                left: -13px;
                right: initial;
                &:before{
                  left: 15px;
                  right: initial;
                }
              }
            }
            &:nth-child(6n){
              .dropdown-menu{
                left: initial;
                right: -13px;
                &:before{
                  left: initial;
                  right: 15px;
                }
              }
            }
          }
        }
      }
    }
  }
}
@media only screen and (max-width: 767.98px) {
  .muzik-member{
    .player-list{
      .block-list{
        >ul{
          li{
            &:nth-child(2n){
              .dropdown-menu{
                left: initial;
                right: -13px;
                &:before{
                  left: initial;
                  right: 15px;
                }
              }
            }
          }
        }
      }
    }
  }
}
@media only screen and (max-width: 368.98px) {
  .pgnnp-header {
    margin: 0 -24px;
  }
}
</style>
